"use client";
import { standardizeOrganizationDisplayName as s } from "./utils/standardize-organization-display-name.js";
import { stripBrandingKeywords as i } from "./utils/strip-branding-keywords.js";
import { standardizeSuffixes as m } from "./utils/standardize-suffixes.js";
import { transformCommonWords as c } from "./utils/standardize-common-words.js";
const g = (r, a) => {
  if (r.type !== "documentation") return [];
  const e = a?.organizationDisplayName;
  return (r.breadcrumbs?.length ? r.breadcrumbs : d(r.url)).map((o) => {
    let t = o;
    return e && (t = s(o, e), t = i(t, e)), t = m(t), t = c(t), t;
  }) ?? [];
}, p = (r) => r.split(/[-_]/).map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()).join(" ");
function d(r) {
  try {
    return new URL(r).pathname.split("/").filter((n) => n.length > 0).slice(0, -1).map(p);
  } catch (a) {
    return console.error("Invalid URL:", a), [];
  }
}
export {
  g as getBreadcrumbs
};
